import React from "react";

const OnlineChatMessages = ({
  currentChat,
  messageInput,
  handleInputChange,
  handleSendMessage,
  handleKeyPress,
  formatTimestamp,
  formatDate
}) => {
  return (
    <main className="chat-main">
      <div className="chat-messages">
        {currentChat.messages.map((message, index) => {
          const showDateSeparator =
            index === 0 ||
            formatDate(message.timestamp) !==
              formatDate(currentChat.messages[index - 1].timestamp);
          return (
            <React.Fragment key={index}>
              {showDateSeparator && (
                <div className="date-separator">
                  {formatDate(message.timestamp)}
                </div>
              )}
              <div
                className={`message ${
                  message.type === "incoming" ? "incoming" : "outgoing"
                }`}
              >
                <span className="message-text">{message.text}</span>
                <span className="timestamp">
                  {formatTimestamp(message.timestamp)}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          className="chat-input"
          placeholder="Type a message..."
          value={messageInput}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        <button className="send-button" onClick={handleSendMessage}>
          Send
        </button>
      </div>
    </main>
  );
};

export default OnlineChatMessages;